module.exports = __webpack_public_path__ + "b5c291cc8fdf1458d0bb6640a7301068.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/mobile/visitor-five-bg.png
// module id = 1189
// module chunks = 0